import React from 'react';
import Tooltip from './common/Tooltip';

/**
 * Small icon indicating the token is delisted from CoinGecko (no longer tracked).
 * Use next to token name/ticker in lists and token page.
 */
const DelistedIcon = ({ className = 'w-4 h-4', size = 'small' }) => (
  <Tooltip
    title="Delisted from CoinGecko — no longer tracked; prices may be cached or unavailable"
    position="top"
    arrow={true}
    animation="shift"
    theme="dark"
    size={size}
    distance={8}
  >
    <span
      className={`inline-flex items-center justify-center ${className}`}
      role="img"
      aria-label="Delisted from CoinGecko"
    >
      ⚠️
    </span>
  </Tooltip>
);

export default DelistedIcon;
